/** @import modules */

import { useState, useEffect }  from "react";

import { useTranslation }       from "react-i18next";

/** @import models */

import OrderSummary             from "../../../Models/OrderSummary";

/**
 * 
 * @returns shopping cart summary
 * 
 */

const totalsCalc = values => { let calculations = 0;

    values.forEach ( element => {

        calculations = calculations + parseFloat ( element.price );

    } );

    return  parseFloat ( calculations.toFixed ( 2 ) );

}

const CartSummary = () => { const { t } = useTranslation (),

    { loading, data, error } = OrderSummary ( "Riga", "LV" );

    if ( error ) {

        console.error ( "[CartSummary] Error loading cart summary:", error );

        // Show error message instead of deleting cart
        return ( <div className="cart_totals">
            
            <ul>
                
                <li className="error">{ t ( "error_loading_summary" ) || "Unable to calculate totals. Please try again." }</li>
                
            </ul>
            
        </div> );

    }

    // Handle case when data is not yet available (loading or skipped query)
    if ( loading ) {

        return ( <div className="cart_totals">
            
            <ul>

                <li>{ t ( "cart_subtotals" ) }: { t ( "calculating" ) } &euro;</li>

                <li>{ t ( "cart_vat" ) }: { t ( "calculating" ) } &euro;</li>

                <li className="highlighted">{ t ( "cart_totals" ) }: { t ( "calculating" ) } &euro;</li>

            </ul>
            
        </div> );

    }

    // Handle case when data is undefined (query was skipped due to empty cart)
    if ( !data || !data.orderPriceCalculator ) {

        return null;

    }

    /** @return component */

    return ( <div className="cart_totals">
            
        <ul>

            <li>{ t ( "cart_subtotals" ) }: { ( data.orderPriceCalculator.total - data.orderPriceCalculator.vat ).toFixed ( 2 ) } &euro;</li>

            <li>{ t ( "cart_vat" ) }: { data.orderPriceCalculator.vat.toFixed ( 2 ) } &euro;</li>

            <li className="highlighted">{ t ( "cart_totals" ) }: { data.orderPriceCalculator.total.toFixed ( 2 ) } &euro;</li>

        </ul>
        
    </div> );

}

/** @export component */
 
export default CartSummary;